import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ALLOW_TRACKING } from '@finder/shared/directives/link-id/link-id.constants';
import { LinkIdDirective } from '@finder/shared/directives/link-id/link-id.directive';
import { LocaleDirective } from '@finder/shared/directives/locale/locale.directive';
import { FontIconComponent } from '../font-icon/font-icon.component';


@Component({
    selector: 'finder-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        LinkIdDirective,
        LocaleDirective,
        FontIconComponent
    ]
})
export class ButtonComponent {
    @Input() id: string;
    @Input() disabled: boolean;
    @Input() href: string;
    @Input() linkId: string;
    @Input() theme: string;
    @Input() fitText: boolean;
    @Input() selected: boolean;
    @Input() fullWidth: boolean;
    @Input() externalLink: boolean;
    @Input() anchor = false;
    @Input() title: string;
    @Input() target = '_self';
    @Input() analyticsTracking = true;
    @Input() ariaControls: string;
    @Input() ariaExpanded: boolean;
    @Input() ariaHasPopup: boolean;
    @Input() ariaLabel: string;
    @Input() ariaSelected: boolean;
    @Input() ariaRole = 'button';
    @Input() tabIndex = 0;
    @Input() icon: string;

    allowTracking = ALLOW_TRACKING;

    constructor() {}
}
